export const STATUS_MAP: Record<string, string> = {
  '0': 'Lập chứng từ',
  '3': 'Chờ duyệt',
  '5': 'Xuất hóa đơn',
  '6': 'Đã xuất hóa đơn điện tử',
  '7': 'Bỏ duyệt đơn hàng'
};
export const HOA_DON_MUA_DICH_VU_EXPORT_TITLE = 'HÓA ĐƠN MUA DỊCH VỤ';
export const HOA_DON_MUA_DICH_VU_FILE_NAME = 'Hóa đơn mua dịch vụ';
export const HOA_DON_MUA_DICH_VU_SHEET_NAME = 'HoaDonMuaDichVu';
